import { render } from "./p-search-screen.vue?vue&type=template&id=ffb9c498&scoped=true"
import script from "./p-search-screen.vue?vue&type=script&lang=js"
export * from "./p-search-screen.vue?vue&type=script&lang=js"

import "./p-search-screen.vue?vue&type=style&index=0&id=ffb9c498&scoped=true&lang=scss"
import "./p-search-screen.vue?vue&type=style&index=1&id=ffb9c498&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffb9c498"],['__file',"src/components/p-search-screen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ffb9c498"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ffb9c498', __exports__)) {
    api.reload('ffb9c498', __exports__)
  }
  
  module.hot.accept("./p-search-screen.vue?vue&type=template&id=ffb9c498&scoped=true", () => {
    api.rerender('ffb9c498', render)
  })

}


export default __exports__